import trackCampaignNoteChanges from '../helpers/trackCampaignNoteChanges'
//---------------------------------------
// process specific campaign note change
//---------------------------------------
export default function processSpecificCampaignNoteChange({
  change = null, // not required for new character campaign note
  campaign_note,
  original_campaign_notes,
  changed_campaign_notes,
  character,
}) {
  console.log('------------------------')
  console.log('IN processSpecificCampaignNoteChange')
  console.log('1. original_campaign_notes = ', window.$deepCopy(original_campaign_notes))
  console.log('2. changed_campaign_notes = ', window.$deepCopy(changed_campaign_notes))
  console.log('3. change = ', change)
  console.log('4. change.key = ' + change?.key)
  console.log('5. change.value = ' + change?.value)
  console.log('6. campaign_note = ', window.$deepCopy(campaign_note))
  //------------------------------------------------------------------------
  // track campaign note changes (performed in charactersheetcampaignnotes)
  //------------------------------------------------------------------------
  changed_campaign_notes = trackCampaignNoteChanges({
    change,
    campaign_note,
    original_campaign_notes,
    changed_campaign_notes,
    character_id: character.id,
  })
  console.log('7. changed_campaign_notes = ', window.$deepCopy(changed_campaign_notes))
  //-------------------------------
  // return changed campaign notes
  //-------------------------------
  return changed_campaign_notes
}
